import { Box, Button, Container, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useReducer, useState } from "react";
import { useHistory } from "react-router-dom";
import EmailInput from "../../components/EmailInput";
import axios from "../../services/api";
import { useForgotPasswordStore } from "../../store/forgotPassword";
import SnackBar from "../../pages/admin/layout/components/Snackback";
import passwordReducer, {
  PasswordsProps,
} from "../../components/ChangePassword/reducer/password.reducer";
import CircularProgress from "@material-ui/core/CircularProgress";
import DefaultButton from "../../components/DefaultButton";
import { ButtonColorCurrentApp, ColorDotsByCurrentApp, ColorDotsNotSelectedByCurrentApp, GradientBackgroundImageByCurrentApp } from "../../utils/get-app-env";

const useStyles = makeStyles((theme) => ({
  root: {
    background: GradientBackgroundImageByCurrentApp(),
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
  },
  container: {
    width: "auto",
    color: "#fff",
  },
  paper: {
    padding: theme.spacing(4),
    maxWidth: 520,
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: theme.spacing(2),
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    color: "#000",
  },
  stepIndicator: {
    display: "flex",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    "& > div": {
      flex: 1,
      height: 8,
      borderRadius: 4,
      marginRight: theme.spacing(1),
      backgroundColor: ColorDotsNotSelectedByCurrentApp(),
      "&:nth-child(1)": {
        backgroundColor: ColorDotsByCurrentApp(),
      },
    },
  },
  stepFilled: {
    width: "33%",
    backgroundColor: "#fff",
    color: "#fff",
  },
  stepEmpty: {
    width: "67%",
    backgroundColor: "#444",
    color: "#fff",
  },
  inputBox: {
    backgroundColor: "#121212",
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
  emailField: {
    color: "#000",
    "& .MuiInputBase-input": {
      color: "#fff",
    },
    "& .MuiInputLabel-root": {
      color: "#bbb",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#555",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottomColor: "#888",
    },
  },
  submitButton: {
    marginBottom: theme.spacing(3),
    backgroundColor: "#ccc", 
    color: "#fff",
    fontWeight: 600,
    transition: "background-color 0.3s ease",
    "&:not(:disabled)": {
      backgroundColor: ButtonColorCurrentApp(),
    },
    "&:not(:disabled):hover": {
      backgroundColor: ButtonColorCurrentApp(),
    },
  },
  footer: {
    marginTop: theme.spacing(3),
    fontSize: 12,
    color: "#aaa",
    textAlign: "center",
  },
  link: {
    color: "#66b2ff",
    textDecoration: "underline",
    marginLeft: 4,
    cursor: "pointer",
  },
}));

const initialState: PasswordsProps = {
  currentPassword: "",
  newPassword: "",
  confirmNewPassword: "",
  errors: [],
  snackbar: {
    isOpen: false,
    message: "",
    type: "info",
  },
};

export default function ForgotPasswordPage() {
  const classes = useStyles();
  const [passwords, dispatch] = useReducer(passwordReducer, initialState);
  const [loading, setLoading] = useState(false);
  const { setEmail, setCanResend, canResend } = useForgotPasswordStore();
  const [emailInput, setEmailInput] = useState("");
  const history = useHistory();

  const handleSubmit = async () => {
    if (!emailInput) return;

    setLoading(true);
    try {
      // Salva o email no store
      setEmail(emailInput);

      // Bloqueia o botão reenviar
      setCanResend(false);

      // Aqui você chama a API para enviar o código
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/forgot-password`,
        {
          email: emailInput,
        }
      );

      // Navega para a tela de verificação
      history.push("/verify-code");
    } catch (error) {
      console.error("Erro ao enviar e-mail:", error);
      dispatch({
        type: "SET_SNACKBAR",
        payload: {
          isOpen: true,
          message: "Erro ao enviar 0 e-mail. Verifique e solicite novamente.",
          type: "error",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box className={classes.root}>
        <Container className={classes.container}>
          <Paper elevation={6} className={classes.paper}>
            <Typography variant="h5" className={classes.title}>
              Esqueceu sua senha?
            </Typography>

            <Box className={classes.stepIndicator}>
              <div />
              <div />
              <div />
            </Box>

            <Typography
              variant="body2"
              style={{ marginBottom: 24, color: "#000" }}
            >
              Verifique seu e-mail e, em seguida, enviaremos as instruções para
              criar uma nova senha:
            </Typography>

            <EmailInput
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
            />
            <br />
            <br />
            <br />
            <Button
              variant="contained"
              fullWidth
              className={classes.submitButton}
              onClick={handleSubmit}
              disabled={!emailInput || loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Enviar"
              )}
            </Button>

            
          </Paper>
        </Container>
      </Box>
      <SnackBar
        children={<>{passwords.snackbar.message}</>}
        open={passwords.snackbar.isOpen}
        feedbackType={passwords.snackbar.type}
        setOpen={() => {}}
        dispatch={() =>
          dispatch({ type: "SET_SNACKBAR", payload: { isOpen: false } })
        }
      />
    </>
  );
}
